import React from 'react';
import { connectRefinementList } from 'react-instantsearch-dom';
import PropTypes from 'prop-types';

const MwobFilter = ({
    // Passed
    attribute,
    label,

    // Algolia
    items,
    currentRefinement,
    refine,
}) => {
    const trueRefinement = items.find(item => item.label === 'true');

    if (!trueRefinement) {
        return null;
    }

    return (
        <li className="ais-RefinementList-item">
            <label className="ais-RefinementList-label">
                <input
                    className="ais-RefinementList-checkbox"
                    type="checkbox"
                    checked={currentRefinement.length > 0}
                    onChange={() => {
                        refine(trueRefinement.value);
                    }}
                />
                <span className="ais-RefinementList-labelText">{label}</span>{' '}
                <span className="ais-RefinementList-count">{trueRefinement.count}</span>
            </label>
        </li>
    );
};

MwobFilter.propTypes = {
    // Passed
    attribute: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,

    // Algolia
    items: PropTypes.array.isRequired,
    currentRefinement: PropTypes.array.isRequired,
    refine: PropTypes.func.isRequired,
};

export default connectRefinementList(MwobFilter);
